import React from 'react';

const formatPreviewCurrency = (dollars) =>
  new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dollars);

const DonationPreview = ({
  primaryColor, coverImageUrl, goalDollars, totalRaisedDollars, progressPct,
  name, description, organizerName,
  previewFrequencies, previewFreq, setPreviewFreq, freqLabels,
  previewAmountRows, showOtherAmount,
  previewAmount, setPreviewAmount, customAmount, setCustomAmount,
  dedicationEnabled, dedicationOptions,
  previewDedicateGift, setPreviewDedicateGift,
  previewDedicationType, setPreviewDedicationType,
  previewHonoree, setPreviewHonoree,
  buttonText, previewButtonLabel,
}) => (
  <div className="gc-public gc-public--form gc-preview-scoped" style={{ '--gc-primary': primaryColor || '#1982C4' }}>
    <div className="gc-form-card">
      {coverImageUrl && (
        <img src={coverImageUrl} alt="Cover" className="gc-form-cover-image" />
      )}

      {goalDollars > 0 && (
        <div className="gc-form-card-body">
          <div className="gc-form-progress-row">
            <span className="gc-form-progress-amount">{formatPreviewCurrency(totalRaisedDollars)}</span>
            <span className="gc-form-progress-goal">{Math.round(progressPct)}% of {formatPreviewCurrency(goalDollars)} goal</span>
          </div>
          <div className="gc-progress-bar">
            <div className="gc-progress-fill" style={{ width: `${progressPct}%` }} />
          </div>
        </div>
      )}

      <div className="gc-form-card-body">
        <h2 className="gc-form-title">{name || 'Your Campaign'}</h2>
        {description && (
          <p className="gc-form-description">{description}</p>
        )}
      </div>

      {organizerName && (
        <div className="gc-form-org-footer">
          <div>
            <div className="gc-form-org-name">Organized by {organizerName}</div>
          </div>
        </div>
      )}
    </div>

    <div className="gc-content-card gc-donation-form" style={{ '--gc-primary': primaryColor || '#1982C4' }}>
      <div className="gc-form-section-title">Choose amount</div>

      {previewFrequencies.length > 1 && (
        <div className="gc-freq-tabs">
          {previewFrequencies.map(f => (
            <button
              key={f}
              type="button"
              className={`gc-freq-tab${previewFreq === f ? ' gc-freq-tab--active' : ''}`}
              onClick={() => setPreviewFreq(f)}
            >
              {freqLabels[f] || f}
            </button>
          ))}
        </div>
      )}

      <div className={`gc-amount-grid${previewAmountRows.some(r => r.description) ? ' gc-amount-grid--has-desc' : ''}`}>
        {previewAmountRows.map(r => (
          <button
            key={r.amount}
            type="button"
            className={`gc-amount-btn${r.description ? ' gc-amount-btn--with-desc' : ''}${previewAmount === r.amount ? ' gc-amount-btn--selected' : ''}`}
            onClick={() => setPreviewAmount(r.amount)}
          >
            <span className="gc-amount-btn-value">${r.amount.toLocaleString()}</span>
            {r.description && <span className="gc-amount-btn-desc">{r.description}</span>}
          </button>
        ))}
        {showOtherAmount && (
          <button
            type="button"
            className={`gc-amount-btn${previewAmount === 'other' ? ' gc-amount-btn--selected' : ''}`}
            onClick={() => setPreviewAmount('other')}
          >
            <span className="gc-amount-btn-value">Other</span>
          </button>
        )}
      </div>

      {previewAmount === 'other' && (
        <div className="gc-custom-amount">
          <span>$</span>
          <input
            type="number"
            placeholder="Enter amount"
            value={customAmount}
            onChange={(e) => setCustomAmount(e.target.value)}
            min="1"
            step="1"
          />
        </div>
      )}

      {previewFreq !== 'one_time' && (
        <div className="gc-recurring-note">
          <strong>Greatest Impact</strong>
          <br />
          Your steady support helps meet ongoing needs and plan for the future.
        </div>
      )}

      {dedicationEnabled && (
        <>
          <div className="gc-checkbox-row" onClick={() => setPreviewDedicateGift(!previewDedicateGift)}>
            <div className={`gc-checkbox${previewDedicateGift ? ' gc-checkbox--checked' : ''}`}>
              {previewDedicateGift && (
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M2.5 6L5 8.5L9.5 3.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              )}
            </div>
            <span className="gc-checkbox-label-text">Dedicate this gift</span>
          </div>

          {previewDedicateGift && (
            <div className="gc-dedicate-fields">
              <select
                className="gc-dedicate-select"
                value={previewDedicationType}
                onChange={(e) => setPreviewDedicationType(e.target.value)}
              >
                <option value="">What type of dedication?</option>
                {dedicationOptions.map((opt, i) => (
                  <option key={i} value={opt}>{opt}</option>
                ))}
              </select>
              <input
                type="text"
                className="gc-dedicate-input"
                placeholder="Who do you want to recognize?"
                value={previewHonoree}
                onChange={(e) => setPreviewHonoree(e.target.value)}
              />
            </div>
          )}
        </>
      )}

      <button type="button" className="gc-give-btn" disabled={!previewAmount || (previewAmount !== 'other' ? false : (parseFloat(customAmount) || 0) <= 0)}>
        {previewButtonLabel}
      </button>
    </div>

    <div className="gc-powered-footer">
      <span>Powered by</span>
      <img src="/assets/Alt@3x.png" alt="Opendate" className="gc-powered-logo" />
    </div>
  </div>
);

export default DonationPreview;
